import Grid from "@mui/material/Grid";
import { Box, Stack, Typography } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostAppliedSingleValue } from "./components/basic/BasicPostApplied";
import { BasicDetail } from "./components/basic/BasicDetail";
import { BasicLanguageDetailMuta } from "./components/basic/BasicLanguage";
import { BasicExperience } from "./components/basic/BasicExperience";
import { BasicSkillsOneLineHorz } from "./components/basic/BasicSkills";
import { BasicPassport } from "./components/basic/BasicPassport";
import { BasicFullName } from "./components/basic/BasicFullName";
import { BasicFaceNoBorder } from "./components/basic/BasicFace";
import { BasicStandNoBorder } from "./components/basic/BasicStand";
import { BasicRemarksUltra } from "./components/basic/BasicRemarks";
import { BasicTitleCenterHorz } from "./components/basic/BasicTitle";
import { BasicReferenceDateOnlyEnglish } from "./components/basic/BasicReference";
import { BasicPassportScan } from "./components/basic/BasicPassportScan";
import {
  BasicHeader,
  BasicHeaderNoBorder,
} from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function MutaTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  //a08745;f2f1f0 fffcf2
  const lineTemplate = {
    ...cvTemplate,
    showCellBorders: true,
    cellBorderBottomOnly: false,
  };
  // bodyHeight: 34,
  // headerHeight: 36,
  // labelFontSize: 14,
  // valueFontSize: 14,

  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
            "& .MuiTable-root tbody tr td:nth-of-type(2), & .MuiTable-root tbody tr td:nth-of-type(3)":
              {
                textAlign: "center",
              },
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              // mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeaderNoBorder
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12}>
              {cvTemplate && currentEmployee && (
                <BasicReferenceDateOnlyEnglish
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                />
              )}
            </Grid>
            {/* Short Photo - left like source sample */}
            <Grid item xs={3}>
              {cvTemplate && currentEmployee && (
                <BasicFaceNoBorder
                  currentEmployee={currentEmployee}
                  template={{
                    ...cvTemplate,
                  }}
                />
              )}
            </Grid>
            <Grid container item xs={9}>
              <Stack spacing={cvTemplate.spacing} sx={{ width: "100%" }}>
                <BasicTitleCenterHorz template={lineTemplate} />
                {cvTemplate && currentEmployee && (
                  <BasicPostAppliedSingleValue
                    currentEmployee={currentEmployee}
                    template={lineTemplate}
                    showHeader={false}
                    showAgent={true}
                    showReferenceNumber={false}
                    showProfession={true}
                    showSalary={true}
                    showContractPeriod={true}
                  />
                )}
              </Stack>
            </Grid>
            <Grid item xs={12}>
              {cvTemplate && currentEmployee && (
                <BasicFullName
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                />
              )}
            </Grid>
          </Grid>

          <Grid item md={6} xs={12}>
            {cvTemplate && currentEmployee && (
              <BasicDetail
                currentEmployee={currentEmployee}
                template={lineTemplate}
                showHeader={true}
                showName={false}
                showNationality={true}
                showReligion={true}
                showDateOfBirth={true}
                showAge={true}
                showPlaceOfBirth={true}
                showMaritalStatus={true}
                showNumberOfChildren={true}
                showWeightHeight={true}
                showComplexion={true}
                showEducation={true}
                showLivingTown={true}
                showEmployeeTelephone={false}
                showContactName={true}
                showContactTelephone={true}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicLanguageDetailMuta
                currentEmployee={currentEmployee}
                template={lineTemplate}
                showEducation={false}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicExperience
                currentEmployee={currentEmployee}
                template={{
                  ...cvTemplate,
                  showCellBorders: true,
                  cellBorderBottomOnly: true,
                }}
                type="basic"
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicSkillsOneLineHorz
                currentEmployee={currentEmployee}
                template={lineTemplate}
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicRemarksUltra
                currentEmployee={currentEmployee}
                template={lineTemplate}
              />
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            <Stack
              spacing={cvTemplate.spacing}
              sx={{
                alignItems: "center",
              }}
            >
              {cvTemplate && currentEmployee && (
                <BasicPassport
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                  showHeader={true}
                  showPassportNumber={true}
                  showIssueDate={true}
                  showPlaceOfIssue={true}
                  showExpiryDate={true}
                />
              )}
              <Stack direction="row" spacing={1}>
                {cvTemplate && currentEmployee && (
                  <BasicStandNoBorder
                    currentEmployee={currentEmployee}
                    template={{
                      ...cvTemplate,
                    }}
                  />
                )}
              </Stack>
              {/* {cvTemplate && currentEmployee && (
                <BasicRemarksConfidential
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                />
              )} */}
              <Box
                sx={{
                  width: "100%",
                  border: `${cvTemplate.borderWidth ?? 1}px ${cvTemplate.borderStyle ?? "solid"} ${cvTemplate.borderColor ?? "#9BAFC3"}`,
                  backgroundColor: cvTemplate.labelBgColor ?? "#e1ebf6",
                  color: cvTemplate.labelFontColor ?? "#002675",
                  p: 0.7,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ textAlign: "center", fontWeight: 700 }}
                >
                  I HEREBY DECLARE THAT THE ABOVE PARTICULARS FURNISHED BY ME
                  ARE TRUE AND ACCURATE TO THE BEST OF MY KNOWLEDGE.
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Box>
      <Stack
        id="passportData"
        sx={{
          p: 1,
          pt: 1,
          backgroundColor: backgroundColor,
          minHeight: "1500px",
        }}
      >
        {cvTemplate.addPassportHeader && (
          <Box
            sx={{
              height: "90%",
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Box>
        )}
        {cvTemplate && currentEmployee && (
          <Box
            sx={{
              mt: 15,
            }}
          >
            <BasicPassportScan
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Box>
        )}
      </Stack>
    </>
  );
}

export default MutaTemplate;
